module.exports = __webpack_public_path__ + "img/possa.bfb17e66.png";